// variables
import { themeOptions } from 'variables';

// libraries
import { Descriptions } from 'antd';
import styled from 'styled-components';

export const StyledBasicDescriptions = styled(Descriptions)`
  .ant-descriptions-view {
    border-radius: 0 !important;
    border: none !important;
    border-top: 0.5px solid #a8a8a8 !important;

    .ant-descriptions-row {
      border-bottom: 0.5px solid #a8a8a8 !important;

      .ant-descriptions-item-label {
        width: 86px !important;
        padding: 10.5px 12px !important;
        color: ${themeOptions.palette.grey[900]} !important;
        background: #f8f8f8;
        white-space: nowrap;
        border-inline-end: none !important;

        > span {
          font-size: 16px;
          font-weight: 500;
          position: relative;

          .required {
            position: absolute;
            right: -12px;
            top: -4px;
            color: ${themeOptions.palette.mainColor};
          }
        }
      }

      .ant-descriptions-item-content {
        height: 50px;
        padding: 0px 5px !important;
        border-inline-end: none !important;

        > span {
          font-size: 16px;
          font-weight: 500;
          color: ${themeOptions.palette.grey[900]} !important;

          .ant-input-disabled {
            border: none;
            padding: 0 16px !important;
            background-color: ${themeOptions.palette.white};

            &.ant-input-outlined {
              border-radius: 0 !important;

              &:focus-within {
                box-shadow: none !important;
              }
            }
          }

          .ant-input {
            height: 40px;
          }

          .ant-select {
            height: 40px;

            .ant-select-arrow {
              .ant-btn-icon-only {
                width: 32px;
                height: 32px;
              }
            }
          }

          .ant-picker {
            width: 100%;
            height: 40px;

            .ant-picker-suffix {
              .ant-btn-icon-only {
                height: 32px;
                width: 32px;

                .ant-btn-icon {
                  width: 20px;
                  height: 20px;
                }
              }
            }
          }
        }
      }
    }
  }
`;
